<template>
  <div class="face-recognition-result-layout">
    <div class="top-nav-face-recognition-result">
      <div class="container">
        <img
          :src="logoSrcUrl"
          alt="Karier.mu"
          class="logo-kariermu"
        />
      </div>
    </div>
    <div class="main-wrapper-face-recognition-result">
      <slot />
    </div>
    <footer-copyright class="hide-on-mobile"></footer-copyright>
  </div>
</template>

<script>

import platinumMixin from '@/mixins/platinumMixin'
import FooterCopyright from '@/components/FooterFaceRecognitionResult'

export default {
  name: 'FaceRecognitionResultLayout',
  components: {
    FooterCopyright
  },
  mixins: [platinumMixin]
}
</script>

<style lang="scss" scoped>
.face-recognition-result-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  .top-nav-face-recognition-result {
    display: flex;
    background-color: var(--color-neutral-100);
    height: 54px;
    padding: 8px 0px;
    -webkit-filter: drop-shadow(0 4px 4px rgb(0 0 0 / 25%));
    filter : drop-shadow(0 4px 4px rgb(0 0 0 / 25%));
    flex-direction: column;
    justify-content: center;

    .logo-kariermu {
      width: 143px;
      object-fit: contain;
      max-height: 30px;
      pointer-events: none;
    }
  }

  .main-wrapper-face-recognition-result {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--color-neutral-400);
  }

  .hide-on-mobile {
    display: flex;

    @media (max-width: 768px) {
      display: none;
    }
  }
}
</style>
